// ============================================================
//  विज्ञापन आकार सेटिङ (Ad Sizes)
// ------------------------------------------------------------
//  width = विज्ञापनको अधिकतम लम्बाइ (यसभन्दा ठूलो हुँदैन,
//  सानो फोटो आफ्नै प्राकृतिक आकारमा देखिन्छ — कट्दैन/तन्दैन)।
//  height = खाली ठाउँ (placeholder) को मात्र उचाइ।
//  नम्बर pixel (px) मा छन्।
// ============================================================

const AD_SIZES = {
  // गृहपृष्ठ माथि — मार्की (ticker) तलको ठूलो ब्यानर
  header: { width: 1100, height: 170 },

  // हेडरभित्र दायाँ छेउमा — ठूलो साइज
  topright: { width: 620, height: 140 },

  // साइडबार माथि
  'sidebar-top': { width: 420, height: 380 },

  // साइडबार तल
  'sidebar-bottom': { width: 420, height: 380 },

  // समाचार (लेख) माथि
  'article-top': { width: 760, height: 180 },

  // नोटिस मोडल / पपअप
  notice: { width: 520, height: 360 },

  // फुटर माथिको ब्यानर
  footer: { width: 1100, height: 150 },

  // समाचार (लेख) भित्रको ब्यानर
  inarticle: { width: 760, height: 140 },

  // गृहपृष्ठ फिड — खेलकुद सेक्सनको तल
  infeed: { width: 1100, height: 160 },
};

export default AD_SIZES;
